/**获取列表*/
export const API_GET_WX_SUPPLIER_LIST = {
  url: 'supplier/query/supplier/openid',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**获取列表 - 超级管理员 */
export const API_GET_SUPPLIER_QUERY_SUPPPLIER_WX = {
  url: 'supplier/query/supplier/wx',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**解绑*/
export const API_POST_UN_BIND = {
  url: 'supplier/del/unbind',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
